import { useState, useEffect } from 'react'

/**
 * Custom hook for managing Groww options favorites
 */
export const useGrowwOptionsFavorites = () => {
  // Initialize favorites from localStorage or empty array
  const [favorites, setFavorites] = useState<string[]>(() => {
    if (typeof window === 'undefined') return []
    const savedFavorites = localStorage.getItem('growwOptionsFavorites')
    return savedFavorites ? JSON.parse(savedFavorites) : []
  })

  // Save favorites to localStorage whenever they change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('growwOptionsFavorites', JSON.stringify(favorites))
    }
  }, [favorites])

  // Add a symbol to favorites
  const addFavorite = (symbol: string) => {
    if (!favorites.includes(symbol)) {
      setFavorites([...favorites, symbol])
    }
  }

  // Remove a symbol from favorites
  const removeFavorite = (symbol: string) => {
    setFavorites(favorites.filter(fav => fav !== symbol))
  }

  // Toggle a symbol's favorite status
  const toggleFavorite = (symbol: string) => {
    if (favorites.includes(symbol)) {
      removeFavorite(symbol)
      return false
    } else {
      addFavorite(symbol)
      return true
    }
  }

  // Check if a symbol is in favorites
  const isFavorite = (symbol: string) => favorites.includes(symbol)

  return { favorites, addFavorite, removeFavorite, toggleFavorite, isFavorite }
}